import { Col, Row, Form, Input } from "antd";
import { MaskInput } from "shared/components";
import { useTranslation } from "react-i18next";
import { formCPFValidator } from "shared/helpers/cpf-validator";

const FormPessoaFisica: React.FC<any> = (props) => {
  const { t } = useTranslation("radar");
  return (
    <Col xs={24}>
      <Row gutter={[16, 16]}>
        <Col xs={12}>
          <Form.Item
            label={t("pages.TeamRequest.completeName")}
            name="name"
            rules={[
              {
                required: true,
                message: t("pages.TeamRequest.completeNameRequired"),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={12}>
          <Form.Item
            label={t("pages.TeamRequest.birthDay")}
            name="birthDay"
            rules={[
              {
                required: true,
                message: t("pages.TeamRequest.birthDayRequired"),
              },
            ]}
          >
            <Input type="date" />
          </Form.Item>
        </Col>
        <Col xs={12}>
          <Form.Item
            label={t("pages.TeamRequest.cpf")}
            name="cpf"
            rules={[
              {
                required: true,
                message: t("pages.TeamRequest.cpfRequired"),
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  return formCPFValidator(value, getFieldValue, "cpf", t);
                },
              }),
            ]}
          >
            <MaskInput mask="999.999.999-99" />
          </Form.Item>
        </Col>
        <Col xs={12}>
          <Form.Item
            label={t("pages.TeamRequest.telefone")}
            name="phone"
            rules={[
              {
                required: true,
                message: t("pages.TeamRequest.telefoneRequired"),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Col>
  );
};
export default FormPessoaFisica;
